import modals from 'webmodals/modals';
import BasicAutoQueryController from 'servicestack/auto-query/auto-query.controller';
import AutoQuery from 'servicestack/auto-query/auto-query';

export default class TableAuditController extends BasicAutoQueryController {
  constructor() {
    super();
    let $ctrl = this;
  }
  $onInit() {
    console.info("tableAudit");
    const $ctrl = this;
      super.$onInit && super.$onInit();
    $ctrl.query = new AutoQuery($ctrl.getQueryOptions());
  }
  getQueryOptions() {
    const $ctrl = this;
    return {
      url: 'QueryTableAudit.json',
      pageSize: 12,
      criteria: {
        keyfield: this.retailerId
      },
      orderBy: '-ChangeOn',
      //append: true,
      autoLoad: true,
      hideLeftNav: true,
      filters: [
        { groupBy: "TableName", title: "TableName" },
        { groupBy: "FieldName", title: "FieldName" }
      ],
      sortOptions: {
        'ChangeOn': 'Date Changed: Newest',
        '-ChangeOn': 'Date Changed: Oldest',
        'TableName': 'TableName: A to Z',
        '-TableName': 'TableName: Z to A'
      }
    };
  }
}